<template>
    <v-card class="mt-1 mx-2" height="725">
        <v-card-title class="justify-center">Accommodation: {{ huis.huis_code }}</v-card-title>
        <v-divider></v-divider>
        <v-card-actions class="ma-0 pa-0">
            <btn_component type="text" text="open all"  class="pa-2" color="primary" tooltip="Open the complete layout" size="x-small" data="" @actionClick="openLayout"/>
            <btn_component type="text" text="close all" class="pa-2" color="primary" tooltip="Close all layout items"   size="x-small" data="" @actionClick="closeLayout"/>
            <v-spacer/>
            <btn_component type="text" text="Export to pdf" class="pa-2" color="primary" tooltip="Export layout" size="x-small" data="" @actionClick="exportLayout"/>
            <btn_component type="text" text="Copy from" class="pa-2" color="primary" tooltip="Copy layout from another house" size="x-small" data="" @actionClick="copyLayout"/>
        </v-card-actions>
        <v-divider/>
        <v-card-text class="ma-0 pa-0 pt-2" v-if="acco.length>0">
            <draggable 
                class="draggable-list" 
                :sort="false"
                :disabled="true" 
                :list="acco" 
                :group="{name: 'layout', pull: 'clone', put: false}" 
                :clone="newItem"
                @end="dragEnd"
                >
                <v-card flat :class="getClass(acco[0])" @drop="onDrop(acco[0])" @dragenter="dragEnter(acco[0].id)">
                    <span :class="getItemClass(acco[0], acco[0])" @click="selectItem(acco[0], null)">{{ acco[0].shortName }}</span>
                </v-card>
            </draggable>
        </v-card-text>
        <v-card-text id="tree" class="ma-0 px-0 py-2 detail-list">
            <v-treeview ref="x" :items="data" item-key="id" :open.sync="openNodes" dense v-scroll:#tree="onScroll">
                <template slot="label" slot-scope="{ item }">
                    <draggable 
                        class="draggable-list" 
                        :sort="false"
                        :disabled="!item.isDraggable" 
                        :list="[item]" 
                        :group="{name: 'layout', pull: 'clone', put: false}" 
                        :clone="newItem"
                        @end="dragEnd"
                        >
                        <v-card flat :class="getClass(item)" @drop="onDrop(item)" @dragenter="dragEnter(item.id)">
                            <span>
                                <btn_component type="icon" icon="mdi-wrench" :color="selected_item === item.id || hoverId === item.id ? 'white' : 'primary'" tooltip="Edit item" size="x-small" :data="item.id" @actionClick="editItem" v-if="item.isEditable"/>
                                <span>
                                    <span :class="getItemClass(item, item)" @click="selectItem(item, null)" v-if="openNodes.includes(item.id)||item.idit_nr<=50">{{ item.shortName }}</span>
                                    <span v-else>
                                        <span :class="getItemClass(item, item)" @click="selectItem(item, null)">{{ item.shortName }}</span>
                                        <span :class="getItemClass(item, item)" v-if="item.hasChildren">:</span>
                                        <span :class="getItemClass(child, item)" @click="selectItem(item, child)" v-for="(child, i) in item.children" :key="i"> {{child.name}}<span v-if="i+1<item.children.length">,</span></span>
                                    </span>
                                    <span class="orange--text" @click="selectItem(item, null)" v-if="!openNodes.includes(item.id)&&hasWarning(item, true)&&item.idit_nr===50">&nbsp;<v-icon color="warning" small>mdi-alert-outline</v-icon></span>
                                </span>
                            </span>
                        </v-card>
                    </draggable>
                </template>
            </v-treeview>
        </v-card-text>
        <hsiiItemCopy        ref="hsiiItemCopy"        @refreshLayout="refreshLayout"/>
        <hsiiItemEditDetails ref="hsiiItemEditDetails" @refreshLayout="refreshLayout" @selectItemById="selectItemById"/>
    </v-card>
</template>

<script>
    import draggable from "vuedraggable";
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import hsiiItemCopy from "@/components/huis/hsii/hsiiItemCopy.vue"; 
    import hsiiItemEditDetails from "@/components/huis/hsii/hsiiItemEditDetails.vue"; 
    
    export default {
        components: {
            draggable,
            btn_component,
            hsiiItemCopy,
            hsiiItemEditDetails,
        },
        props: {
            huis_encrid: {
                type: String,
                required: true                
            },
        },
        watch: {
            openNodes(newValue, oldValue) {
                let added = newValue.filter(item => !oldValue.includes(item));
                let removed = oldValue.filter(item => !newValue.includes(item));
                if (added.length === 1) {
                    if (this.selected_item !== added[0]) {
                        this.selectId(added[0]);
                    } else {
                        // bij openklappen een eventueel geselecteerd child selecteren
                        if (this.selected_child !== "x") {
                            this.selectId(this.selected_child);
                        }
                    }
                }
                if (removed.length === 1) {
                    this.selectId(removed[0]);
                }
            }
        },
        data() {
            return {
                setNodes: true,
                huis: {},
                acco: [],
                data: [],
                target: "",
                selected_item: "x",
                selected_child: "x",
                timer: null,
                doubleActive: false,
                newOffset: 0,
                offset: 0,
                item: null,
                newDropItem: null,
                openNodes : [],
                scrollOptions: {
                    container: "#tree",
                    duration: 0,
                    offset: 0,
                    easing: "easeInOutCubic",
                },
                hoverId: "",
            }
        },
        mounted() {
            this.selected_item = "x";
            this.selected_child = "x";
            this.setNodes = true;
            this.getHsiiOverview();
        },
        methods: {
            getClass(item) {
                if (item.id === this.hoverId) {
                    return "blue px-2 arrow";
                }
                if (item.id === this.selected_item) {
                    return "primary px-2 arrow";
                }
                return "px-2 arrow";
            },
            getItemClass(item, parent) {
                let weight = "";
                let cl = this.getClass(parent) + " ";
                if (item.id === this.selected_child) {
                    // weight = "font-weight-black ";
                    weight = "font-weight-bold ";
                }
                if (this.selected_child === "x" && item.id === this.selected_item) {
                    weight = "font-weight-bold ";
                }
                cl = cl + weight;
                if (item.messages.length > 0) {
                    return cl + "orange--text";
                }
                if (item.id === this.selected_item) {
                    return cl + "white--text";
                }
                if (parent.id === this.selected_item) {
                    return cl + "white--text";
                }
                if (item.id === this.hoverId) {
                    return cl + "white--text";
                }
                if (parent.id === this.hoverId) {
                    return cl + "white--text";
                }
                return cl + "blue--text";
            },

            getHsiiOverview() {
                // Voordat we het scherm verversen, eerst de huidige positie bewaren, dan kunnen we deze terug zetten.
                this.offset = this.getScroll();
                this.$axios.post("ares/json/ares/huis/hsii/getHsiiOverview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsiiOverview"
                    },
                    getHsiiOverview: {
                        huis_encrid: this.huis_encrid,
                        pre_select: this.selected_item,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {
                        this.huis = res.data.getHsiiOverview;
                        this.data = this.huis.combined;
                        this.makeShortNames(this.data);
                        if (this.setNodes) {
                            this.closeLayout();
                            this.setNodes = false;
                        }
                        this.refreshSelected(this.data);
                        this.acco = [this.data[0]];
                        this.data = this.data[0].children;
                    }
                });
            },
            makeShortNames(data) {
                for (let iIndex=0;iIndex<data.length;iIndex++) {
                    if (data[iIndex].hasChildren) {
                        data[iIndex].shortName = data[iIndex].name.split(":")[0];
                        this.makeShortNames(data[iIndex].children);
                    } else {
                        data[iIndex].shortName = data[iIndex].name;
                    }
                }
            },
            getColor(item) {
                if (item.id === this.selected_item) {
                    return "primary";
                }
                return "white";
            },
            openLayout() {
                this.openNodes = [];
                this.openAllNodes(this.data);
            },
            openAllNodes(nodes) {
                for (let iIndex = 0;iIndex<nodes.length;iIndex++) {
                    this.openNodes.push(nodes[iIndex].id);
                    if (nodes[iIndex].hasChildren) {
                        this.openAllNodes(nodes[iIndex].children)
                    }
                }
            },
            closeLayout() {
                this.openNodes = [];
                // if (this.data.length > 0) {
                //     this.openNodes.push(this.data[0].id);
                // }
            },
            hasWarning(item, root) {
                if (!root && item.messages.length>0) {
                    return true;
                }
                if (item.hasChildren) {
                    for (let iIndex=0;iIndex<item.children.length;iIndex++) {
                        if (this.hasWarning(item.children[iIndex], false)) {
                            return true;
                        }
                    }
                }
                return false;
            },
            onScroll(e) {
                this.newOffset = e.target.scrollTop
            },
            getScroll() {
                return this.newOffset;
            },
            setScroll(offset) {
                // 64 omdat dit werkt, heb nog geen idee waar deze verloren gaan.
                this.$vuetify.goTo(offset + 64, this.scrollOptions)
            },
            refreshLayout() {
                // this.getHsiiOverview();
                this.$emit("refreshLayout");
            },
            toggleLayout() {
                this.$emit("toggleLayout");
            },
            toggleItem(hsii_encrid) {
                this.$emit("toggleEdit", hsii_encrid);
            },
            startDoubleClick(item) {
                clearTimeout(this.timer);
                this.doubleActive = false;
                if (item.isEditable) {
                    // Start een niewue timer voor deze klik
                    this.doubleActive = true;
                    this.timer = setTimeout( () => { this.doubleActive = false; }, 700);
                }
            },
            selectRow(item, child_id) {
                if (this.selected_item === item.id&&this.selected_child === child_id) {
                    // Click op zelfde item
                    if (this.doubleActive) {
                        // Er is op hetzelfte item een klik gedaan, en de timer was nog actief, "doubleclick" : open edit
                        clearTimeout(this.timer);
                        this.doubleActive = false;
                        if (this.selected_child !== "x") {
                            // Er is een child geselecteerd: edit deze
                            this.editItem(this.selected_child);
                        } else {
                            // Er is geen child geselecteerd: edit het item zelf
                            this.editItem(this.selected_item);
                        }
                        return;
                    }
                    this.startDoubleClick(item);
                }
                // Click op een ander item, is meteen eerste van een dubbel click
                this.selected_item = item.id;
                this.startDoubleClick(item);
            },
            selectItemById(item_id, child_id) {
                if (item_id === "x") {
                    this.selectItem(this.getItemFromId(this.data, this.selected_item), this.getItemFromId(this.data, child_id));
                } else {
                    this.selectItem(this.getItemFromId(this.data, item_id), this.getItemFromId(this.data, child_id));
                }
            },
            selectItem(item, child) {
                if (this.selected_item !== item.id) {
                    if (!child) {
                        this.$emit("newDetails", item.id);
                    }
                }
                // this.selectRow(item);
                if (child) {
                    // Er is een child selected
                    this.selectRow(item, child.id);
                    if (this.selected_child !== child.id) {
                        this.$emit("newDetails", child.id);
                        this.selected_child = child.id;
                    }
                } else {
                    this.selectRow(item, "x"); 
                    if (this.selected_child !== "x") {
                        // Click buiten child: selecteer parent
                        this.$emit("newDetails", item.id);
                        this.selected_child = "x";
                    }                    
                }
            },
            refreshSelected(data) {
                for (let iIndex = 0;iIndex<data.length;iIndex++) {
                    if (this.selected_child === data[iIndex].id) {
                        this.$emit("selectItem", data[iIndex].id);
                        return;
                    }
                    if ((this.selected_child === "x") && (this.selected_item == data[iIndex].id)) {
                        this.$emit("selectItem", data[iIndex].id);
                        return;
                    }
                    if (data[iIndex].hasChildren) {
                        this.refreshSelected(data[iIndex].children)
                    }
                }
            },
            getItemFromId(items, id) {
                if (id) {
                    for (let iIndex=0;iIndex<items.length;iIndex++) {
                        if (items[iIndex].id === id) {
                            return items[iIndex];
                        }
                        if (items[iIndex].hasChildren) {
                            let child = this.getItemFromId(items[iIndex].children, id);
                            if (child) {
                                return child;
                            }
                        }
                    }
                }
                return null;
            },
            selectId(id) {
                let item = this.getItemFromId(this.data, id);
                if (item) {
                    this.selectItem(item, null);
                }
            },
            editItem(id) {
                document.activeElement.blur();
                this.$refs.hsiiItemEditDetails.openDialog(this.huis_encrid, id);
            },
            deleteItem(id) {
                document.activeElement.blur();
                this.$refs.hsiiItemEditDetails.openDialog(this.huis_encrid, id);
            },
            exportLayout() {
                this.$axios.post("ares/json/ares/huis/hsii/exportLayout.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "exportLayout"
                    },
                    exportLayout: {
                        huis_encrid: this.huis_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {
                         window.open(res.data.exportLayout.pdfname, "_blank");
                    }
                });
            },
            copyLayout() {
                this.$refs.hsiiItemCopy.openDialog(this.huis_encrid, this.selected_item);
            },
            newItem(data) {
                if (data.item_type === "new") {
                    this.newDropItem = data;
                    return;
                }
                this.newDropItem = null;
                this.item = data;
                this.selectItem(data, null);
            },
            addItem(item) {
                this.$axios.post("ares/json/ares/huis/hsii/addHsii.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHsii"
                    },
                    addHsii: {
                        huis_encrid: this.huis_encrid,
                        hsii_encrid: item.id,
                        indi_nr: (this.newDropItem) ? this.newDropItem.indi_nr : this.item.indi_nr,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {          
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addHsii.text,
                            color: res.data.addHsii.color
                        }); 
                        
                        if (res.data.addHsii.color === "success") {

                            if (this.openNodes.includes(res.data.addHsii.parent_id)) {
                                // Parent is open node, select child
                                this.selected_item = res.data.addHsii.new_id;
                                this.selected_child = "x";
                            } else {
                                // Parent is closed node, select parent & child
                                this.selected_item = res.data.addHsii.parent_id;
                                this.selected_child = res.data.addHsii.new_id;
                            }
                            this.refreshLayout();
                        }
                    }
                });
            },
            moveItem(hsii_encrid_from, hsii_encrid_to) {
                this.$axios.post("ares/json/ares/huis/hsii/moveHsii.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "moveHsii"
                    },
                    moveHsii: {
                        huis_encrid: this.huis_encrid,
                        hsii_encrid_from: hsii_encrid_from,
                        hsii_encrid_to: hsii_encrid_to,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {          
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.moveHsii.text,
                            color: res.data.moveHsii.color
                        }); 
                        if (res.data.moveHsii.color === "success") {
                            this.refreshLayout();
                        }
                    }
                });
            },
            onDrop(item) {
                this.hoverId = "";
                let dropItem = this.item;
                if (this.newDropItem) {
                    dropItem = this.newDropItem;
                }
                switch(dropItem.item_type) {
                    case "new":
                        if (dropItem.idit_level <= item.idit_level) {
                            // item niet toevoegen aan item met een gelijk of hoger niveau!! 
                            this.$store.dispatch('setSnackbar', {
                                showing: true,
                                text: "Layout item can't be added here",
                                color: "warning"
                            }); 
                            return;
                        }
                        this.addItem(item);
                        break;
                    case "existing":
                        if (dropItem.id === item.id) {
                            // item niet naar zichzelf verplaatsen!! 
                            // geen waarschuwing tonen
                            // this.$store.dispatch('setSnackbar', {
                            //     showing: true,
                            //     text: "Layout item can't be moved to itself",
                            //     color: "warning"
                            // }); 
                            return;
                        }
                        if (dropItem.idit_level <= item.idit_level) {
                            // item niet naar item met een gelijk of hoger niveau verplaatsen!! 
                            this.$store.dispatch('setSnackbar', {
                                showing: true,
                                text: "Layout item can't be moved here",
                                color: "warning"
                            }); 
                            return;
                        }
                        this.moveItem(dropItem.id, item.id);
                        break;
                }
            },
            dragEnter(id) {
                this.hoverId = id;
            },
            dragEnd() {
                this.hoverId = "";
            }

        }  
    };
</script>

<style scoped>
    .v-card {
        display: flex !important;
        flex-direction: column;
    }

    .detail-list {
        flex-grow: 1;
        overflow-y: auto;
    }

    .arrow {
        cursor: default
    }
    
    .grab {
        cursor: grab
    }
</style>
